module.exports = __webpack_public_path__ + "static/media/home-show-panel-loading.72e8d706.svg";